import {
    HelperText,
    SettingName,
    SettingRow,
    SettingValue,
    StackedSettingValue,
} from 'components/node_settings/V4Settings/styled';
import { ReactNode } from 'react';

type SettingProps = Readonly<{
    name: ReactNode;
    indented?: boolean;
    stacked?: boolean;
    helperText?: ReactNode;
    children: ReactNode;
}>;

export function Setting({
    name,
    indented = false,
    stacked = false,
    helperText,
    children,
}: SettingProps) {
    return (
        <SettingRow>
            <SettingName $indented={indented}>{name}</SettingName>
            {stacked ? (
                <StackedSettingValue>{children}</StackedSettingValue>
            ) : (
                <SettingValue>{children}</SettingValue>
            )}
            {helperText ? <HelperText>{helperText}</HelperText> : null}
        </SettingRow>
    );
}
